import app from 'flarum/common/app';
/**
 * 统一前缀
 */
export const extPrefix = 'imdong-spam-alert';

/**
 * 获取一个 key
 * @param key
 */
export function key(key) {
  return `${extPrefix}.${key.replace(/^\.*/, '')}`;
}

/**
 * 获取特定 key 的翻译
 * @param id
 * @param parameters
 */
export function trans(id, parameters = {}) {
  return app.translator.trans(key(id), parameters);
}
export default {
  extPrefix,
  key,
  trans
};